/* tslint:disable */
/* eslint-disable */
export enum AlarmOption {
  NoAlarm = 0,
  AlarmAtEnd = 1,
  AlarmAtThirtySecondsRemaining = 2,
  AlarmAtOneMinuteRemaining = 3
}
